import { requestJson } from './client';

export interface PublicConfig {
  adminPublicUrl?: string | null;
  webPublicUrl?: string | null;
}

let cachedConfig: PublicConfig | null = null;

export async function getPublicConfig(): Promise<PublicConfig> {
  if (cachedConfig) return cachedConfig;
  cachedConfig = await requestJson<PublicConfig>('/api/public-config');
  return cachedConfig;
}

export async function redirectToAdminApp(path = '/dashboard') {
  const config = await getPublicConfig();
  const base = config.adminPublicUrl?.replace(/\/+$/, '');
  window.location.assign(base ? `${base}${path}` : path);
}
